import { render, staticRenderFns } from "./eventTicketListComponent.vue?vue&type=template&id=b18b433a&"
import script from "./eventTicketListComponent.vue?vue&type=script&lang=ts&"
export * from "./eventTicketListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports